// extracted by mini-css-extract-plugin
export default {"groupSelector":"V8AsxiVy"};